import { render, staticRenderFns } from "./ModalConfiguracion.vue?vue&type=template&id=87bf1a5a&"
import script from "./ModalConfiguracion.vue?vue&type=script&lang=js&"
export * from "./ModalConfiguracion.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfiguracion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports